import React, { useState, useEffect } from "react";
import "./Campousphoto.css";
import { resources } from "../../Resourses/Resources";
import axios from "axios";
import Loader from "../../../Loader/Loader";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "animate.css";
import Select from "react-select";
import Cookies from "js-cookie";


const Capmousphotos = () => {
  const [events, setEvents] = useState([]);
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const userDetailsCookie = Cookies.get("userDetails");
   const [role, setRole] = useState("");

  // Fetch available events from backend


    useEffect(() => {
      if (userDetailsCookie != null && userDetailsCookie != "") {
        const userDetails = JSON.parse(userDetailsCookie);
        const details = userDetails.roles[0];
        
        setRole(details);
       
      }
    }, [userDetailsCookie]);
  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const res = await axios.get(`${resources.APPLICATION_URL}listofevents`);
        if (res.data) {
          setEvents(res.data);
        }
      } catch (error) {
        console.error("Error fetching events:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchEvents();
  }, []);

  // Fetch images for selected event
  const fetchImages = async (eventName) => {
    if (!eventName) return;
    setLoading(true);
    setSelectedEvent(eventName);

    try {
      const res = await axios.get(`${resources.APPLICATION_URL}listofevents/${eventName}`);
      console.log("Fetched images:", res.data);

      const formattedImages = res.data.map((imgObj) => {
        const photoName = Object.keys(imgObj)[0];
        return {
          photoName,
          base64: imgObj[photoName],
        };
      });

      setImages(formattedImages);
    } catch (error) {
      console.error("Error fetching images:", error);
      setImages([]);
    } finally {
      setLoading(false);
    }
  };

  // Delete an entire event
  const deleteEvent = async () => {
    if (!selectedEvent) return;

    if (!window.confirm(`Are you sure you want to delete the event "${selectedEvent}"?`)) {
      return;
    }

    try {
      await axios.delete(`${resources.APPLICATION_URL}deleteEventByName/${selectedEvent}`);
      alert(`Event "${selectedEvent}" deleted successfully.`);
      setEvents(events.filter(event => event !== selectedEvent));
      setImages([]);
      setSelectedEvent("");
    } catch (error) {
      console.error("Error deleting event:", error);
    }
  };

  // Delete a single image
  const deleteImage = async (imgData) => {
    if (!window.confirm("Are you sure you want to delete this image?")) return;

    try {
      await axios.delete(
        `${resources.APPLICATION_URL}deleteCampusPhotoByPhotoName/${encodeURIComponent(imgData.photoName)}`
      );

      alert("Image deleted successfully.");
      setImages((prevImages) => prevImages.filter((img) => img.photoName !== imgData.photoName));
    } catch (error) {
      console.error("Error deleting image:", error);
      alert("Failed to delete image.");
    }
  };

  const eventOptions = events.map((event) => ({
    value: event,
    label: event,
  }));

  const sliderSettings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: true,
    adaptiveHeight: true,
    autoplay: true,
  };

  return (
    <div className="gallery_main">
      <div className="gallery_header">
        <h2>Campus Photos View</h2>
      </div>

      <div className="gallery_dropdown">
        <select
          value={selectedEvent}
          className="event-dropdown"
          placeholder="Search or Select an Event"
          onChange={(e) =>
            fetchImages(e.target.value)
          }
        ><option>select</option>
        {events.map((each,index)=>(
          <option value={each} key={index}>{each}</option>
        ))}</select>
         {role === "ROLE_MANAGEMENT" && role !== "" && (<button
          type="button"
          className="Event-btn"
          onClick={deleteEvent}
          disabled={!selectedEvent}
        >
          Delete Event
        </button>)}
      </div>

      {loading ? (
        <div className="loader">
          <Loader />
        </div>
      ) : (
        <div className="gallery_curousel">
          {images.length > 0 ? (
            <Slider {...sliderSettings}>
              {images.map((imageData, id) => (
                <div key={id} className="slide">
                  <div className="card-body">
                    <img
                      className="campous_imgs"
                      src={`data:image/png;base64,${imageData.base64}`}
                      alt={`Event Image ${id + 1}`}
                    />
                 {role === "ROLE_MANAGEMENT" && role !== "" && ( <button
                      type="button"
                      className="delete_image_btn"
                      onClick={() => deleteImage(imageData)}
                    >
                      Delete Image
                    </button>)}
                  </div>
                </div>
              ))}
            </Slider>
          ) : (
            <div className="no-images">
              <h2>Please select an event to view images...</h2>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Capmousphotos;
